import React, { useEffect, useState } from "react";
import { DatePicker, Select } from "antd";
import dayjs from "dayjs";
import axios from "axios";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import MonthlyGrossProfitReport from "./MonthlyGrossProfitReport";
import AllTimeGrossProfit from "./AllTimeGrossProfit";

export default function MainGrossProfitReport({ tabChange }) {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const TIMEZONE = "Asia/Dhaka";

  const getThisMonthRange = () => {
    const startOfMonth = dayjs().tz(TIMEZONE).startOf("month");
    const endOfMonth = startOfMonth.endOf("month");

    const formattedStartDate = startOfMonth.format(
      "ddd, DD MMM YYYY HH:mm:ss [GMT+6]"
    );
    const formattedEndDate = endOfMonth.format(
      "ddd, DD MMM YYYY HH:mm:ss [GMT+6]"
    );

    return [formattedStartDate, formattedEndDate];
  };
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [reportType, setReportType] = useState("Monthly Report");
  const [centerList, setCenterList] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState(
    getThisMonthRange()
  );
  const [selectedCenterName, setSelectedCenterName] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${config.baseUrl}/inventory/product_supplier_center_list/`,
          {
            headers: authHeader(),
          }
        );
        setCenterList(response?.data?.centers);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [tabChange]);

  useEffect(() => {
    setReportType("Monthly Gross Profit Report");
    setSelectedDateRange(getThisMonthRange());

    setSelectedCenterName(null);
  }, [tabChange]);

  const handleReportSelection = (value) => {
    setReportType(value);
    setSelectedCenterName(null);

    setSelectedDateRange(
      value === "Monthly Gross Profit Report" ? getThisMonthRange() : []
    );
  };

  const handleCenterSelection = (value) => {
    setSelectedCenterName(value);
  };

  const handleDateRangeChange = (value) => {
    if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
      let startDate = dayjs.tz(value[0], TIMEZONE).startOf("month");
      let endDate = dayjs.tz(value[1], TIMEZONE).endOf("month");

      const formattedStartDate = startDate.format(
        "ddd, DD MMM YYYY HH:mm:ss [GMT+6]"
      );
      const formattedEndDate = endDate.format(
        "ddd, DD MMM YYYY HH:mm:ss [GMT+6]"
      );

      setSelectedDateRange([formattedStartDate, formattedEndDate]);
    } else {
      setSelectedDateRange(null);
    }
  };
  return (
    <>
      <Select
        placeholder="Select Report Type"
        className="ms-2"
        onChange={handleReportSelection}
        value={reportType}
        style={{ width: "350px" }}
      >
        <Option value="Monthly Gross Profit Report">
          Monthly Gross Profit Report
        </Option>

        <Option value="All-Time Gross Profit Report">
          All-Time Gross Profit Report
        </Option>
      </Select>

      <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
        <div>
          {reportType !== "All-Time Gross Profit Report" && (
            <RangePicker
              placeholder={["Receive Date", ""]}
              className="me-3"
              onChange={handleDateRangeChange}
              value={
                selectedDateRange
                  ? selectedDateRange.map((date) => dayjs(date))
                  : null
              }
              picker="month"
              style={{ width: "320px" }}
            />
          )}
          <Select
            placeholder="Select Center"
            className="me-3"
            onChange={handleCenterSelection}
            value={selectedCenterName}
            style={{ width: "200px" }}
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
          >
            {centerList?.map((center) => (
              <Option value={center?.center_name} key={center?.center_name}>
                {center?.center_name}
              </Option>
            ))}
          </Select>
        </div>
      </div>

      {reportType === "Monthly Gross Profit Report" && (
        <MonthlyGrossProfitReport
          dateRange={selectedDateRange}
          centerName={selectedCenterName}
        />
      )}

      {reportType === "All-Time Gross Profit Report" && (
        <AllTimeGrossProfit centerName={selectedCenterName} />
      )}
    </>
  );
}
